<template>
    <div
        class="collapse"
        :class="containerClasses"
    >
        <div
            class="flex justify-between items-center cursor-pointer"
            @click="toggle"
        >
            <div
                class="collapse__title__text"
                :class="titleClasses"
            >
                <slot name="title"></slot>
            </div>
            <IconRenderer
                name="DoubleChevron"
                class="fill-current w-6"
                :class="iconClasses"
            />
        </div>
        <div
            class="text-sm lg:text-base"
            :class="contentClasses"
        >
            <slot name="content"></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        variant: {
            type: String,
            default: 'alpha'
        }
    },

    data() {
        return {
            open: false
        }
    },

    computed: {
        containerClasses() {
            const classes = ['border-t', 'border-b'];

            switch (this.variant) {
                case 'alpha':
                    classes.push('border-midnight');
                    classes.push('py-6');
                    break;
            }

            return classes;
        },

        titleClasses() {
            let classes = [];

            switch (this.variant) {
                case 'alpha':
                    classes.push('lg:text-lg');
                    break;
            }

            return classes;
        },

        iconClasses() {
            const classes = [];

            if (this.open) {
                classes.push('transform');
                classes.push('rotate-180');
            }

            return classes;
        },

        contentClasses() {
            let classes = [];

            switch (this.variant) {
                case 'alpha':
                    classes.push('pt-6');
                    break;
            }

            if (!this.open) {
                classes.push('hidden')
            }

            return classes;
        }
    },

    methods: {
        toggle() {
            this.open = !this.open;
        }
    }
}
</script>

<style>
.collapse {
    + .collapse {
        border-top: 0 !important;
    }
}
</style>
